import {
  Component,
  Input,
  ContentChildren,
  TemplateRef,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';


export class SkyGridColumnComponent {
  
  public id: string;
  
  public heading: string;
  
  public width: number;
  
  public hidden: boolean;
  
  public locked: boolean;
  
  public field: string;
  
  public type: string;
  
  public description: string;
  
  public isSortable: boolean = true;

  /* tslint:disable */
  
  private searchFunction: (value: any, searchText: string) => boolean = this.search;

  
  private templateInput: TemplateRef<any>;
  /* tslint:enable */

  
  private templates: QueryList<TemplateRef<any>>;

  public get template(): TemplateRef<any> {
    return (this.templates.length > 0 ? this.templates.first : undefined) || this.templateInput;
  }

  private search(value: any, searchText: string): boolean {
    /* tslint:disable */
    if (value !== undefined && value !== null) {
      return value.toString().toLowerCase().indexOf(searchText) !== -1;
    }
    /* tslint:enable */

    return false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-grid-column',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'id': [{ type: Input },],
'heading': [{ type: Input },],
'width': [{ type: Input },],
'hidden': [{ type: Input },],
'locked': [{ type: Input },],
'field': [{ type: Input },],
'type': [{ type: Input },],
'description': [{ type: Input },],
'isSortable': [{ type: Input },],
'searchFunction': [{ type: Input, args: ['search', ] },],
'templateInput': [{ type: Input, args: ['template', ] },],
'templates': [{ type: ContentChildren, args: [TemplateRef, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
